import React from 'react'

const Homesection4Card1 = (props) => {
  return (
    <div className="mx-6  rounded-br-3xl  mt-14 flex h-64 cursor-pointer flex-col items-center justify-center rounded border border-x-0 border-y-2 shadow-2xl hover:bg-gradient-to-r from-white to-gray-300 lg:w-1/4">
    <img
      className="mx-52 w-12"
      src={props.image}
      alt=""
    />
    <h1 className="pt-3 text-center font-serif text-2xl  lg:w-fit">{props.title}</h1>
  </div>
  )
}

export default Homesection4Card1